/**
 * use for example in debug console logs to reduce verboseness
 *
 */

import { MapLike } from '@iotv/iotv-v3-types'

export const showKeysPresent = (o: MapLike<any>): string => {
  let missing: string[] = []
  let present: string[] = []
  Object.entries(o).forEach(([k, v]) => {
    if (v) {
      present.push(k)
    } else {
      missing.push(k)
    }
  })
  const str = `missing: ${missing.join(', ')}, present: ${present.join(', ')}`
  return str
}
